var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpluggedStatusAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#B1CBD9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.1082V24.1498C16 25.2635 15.0955 26.1875 14.0128 25.9673C9.44193 25.0381 6 20.9659 6 16.0832C6 14.2294 6.49614 12.4925 7.36182 11M20.3641 25.1581C23.7003 23.5239 26 20.0743 26 16.0832C26 10.5144 21.5228 6 16 6C14.1786 6 12.4709 6.49102 11 7.34895",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.8C13 15.3582 13.3582 15 13.8 15H18.2C18.6418 15 19 15.3582 19 15.8V16C19 17.6569 17.6569 19 16 19C14.3431 19 13 17.6569 13 16V15.8Z",
    stroke: "#344054",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15V13",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 15V13",
    stroke: "#344054",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpluggedStatusAlert);
export default __webpack_public_path__ + "static/media/unpluggedStatusAlert.ae31e6e836ab90adf5cc3c089c607bde.svg";
export { ForwardRef as ReactComponent };